<template>
    <div class="text-right print-down">
        <a @click="printReport" href="javascript:void(0)">
            <img src="https://uteachnew.s3.amazonaws.com/uteach/assets/printer.svg" alt="printer icon" width="16" height="15">
            {{ trans('Print') }}
        </a>
    </div>
</template>

<script>
export default {
    name: "Download",

    props: {
        reportId: {
            required: true,
        }
    },
    data() {
        return {
            cssUrl: null,
        }
    },
    methods: {
        printReport() {
            const divToPrint = $('.quiz-finish-blocks');
            const newWin = window.open('', 'Print-Window');
            newWin.document.open();
            newWin.document
                .write(
                    `<html>
                        <link href="${this.cssUrl}" rel="stylesheet">
                        <body onload="window.print()">
                            ${divToPrint.html()}
                        </body>
                     </html>`
                );
            newWin.document.close();

            if (navigator.userAgent.includes("Firefox")) {
                const iter = setInterval(() => {
                    if (newWin.closed) {
                        clearInterval(iter);
                    } else {
                        newWin.close();
                    }
                }, 500);
            } else {
                newWin.addEventListener('afterprint', function () {
                    newWin.close();
                });
            }
        },
        fetchCssUrl() {
            axios.get('/resources/css-url')
                .then(response => {
                    this.cssUrl = response.data.url
                })
        },
    },
    mounted() {
        this.fetchCssUrl();
    }
}
</script>

<style scoped>
.print-down a{
    white-space: nowrap;
}
</style>
